// Pagina actual del listado de carpetas. La pagina se guarda junto con la
// "clave de vista" (carpeta abierta + filtro) en la que el usuario la eligio;
// si la vista cambia, la pagina efectiva vuelve a 1 sin esperar a un efecto.

export const viewKey = (folderPath, onlyUnaccounted) =>
    `${folderPath || ''}|${onlyUnaccounted ? 'sc' : 'todos'}`;

export const pageFor = (state, key) =>
    (state && state.key === key && state.page >= 1 ? state.page : 1);

export const pageState = (key, page) => ({ key, page });

// Descarta la pagina guardada si pertenece a otra vista: asi volver a una
// carpeta anterior (sin haber paginado en la intermedia) abre en la pagina 1.
export const syncPageState = (state, key) => (state && state.key !== key ? null : state);
